/** Runtime config derived from Vite env (with sensible production defaults). */

export const APP_ORIGIN =
  import.meta.env.VITE_APP_ORIGIN || "https://app.makerstack.altuzar.dev"

export const PUBLIC_ORIGIN =
  import.meta.env.VITE_PUBLIC_ORIGIN || "https://makerstack.altuzar.dev"

// The Convex client URL is public configuration, not a secret. Keep a production
// default so direct/static deployments cannot silently compile a broken client.
export const CONVEX_URL =
  import.meta.env.VITE_CONVEX_URL || "https://warmhearted-retriever-137.convex.cloud"

/** Public URL of a maker's live page. */
export function publicPageUrl(username: string): string {
  return `${PUBLIC_ORIGIN}/${username}`
}

/** URL of the editor on the app subdomain (used by the landing claim CTA). */
export function appUrl(path = "/"): string {
  return `${APP_ORIGIN}${path}`
}
